export default {
  titles: {
    default: 'Påmindelse om planlagt ordre!',
    external_delivery: 'Chauffør tildelt!',
  },
  labels: {
    pickup: 'Afhentning: {{time}}',
    preparation_time: 'Tilberedningstid: {{time}} min.',
  },
  buttons: {
    confirm: 'Start tilberedning nu',
    print_and_confirm: 'Udskriv og start tilberedning nu',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt. Prøv igen',
  },
};
